import { render, staticRenderFns } from "./addShopSetting.vue?vue&type=template&id=a5c880b2"
import script from "./addShopSetting.vue?vue&type=script&lang=js"
export * from "./addShopSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports